import type { StringBank } from '../schema/strings';
export default {
  name: 'Professor Reed',
  greeting: 'Ah, {player}. Mind the plinths, they bruise easily. How may the museum help?',
  identifyNone: 'Nothing for me to squint at today? Bring me something muddy.',
  identified: 'Hold still… yes. That is {fossil:a}. Splendid mud you found it in.',
  identifiedMany: '{n} fossils! I have identified them all. Do try not to drop the heavy ones on your foot.',
  donatePrompt: 'Something for the collection? Show me what you have found.',
  donateThanks: 'Thank you, {player}. The {item:lc} goes on display at once, with your name on the plaque.',
  alreadyDonated: 'We already have {item:a}, I am afraid. The shop will happily take it off your hands.',
  notDonatable: 'Lovely, but the museum only collects fossils and fish.',
  unidentified: 'Let me identify that first. Even I cannot label a mystery.',
  hallFossilsName: 'fossil hall', hallFishName: 'aquarium',
  hallFossils: 'The fossil hall is complete. I may need to sit down.',
  hallFish: 'Every tank is full. The fish are insufferably pleased with themselves.',
  letterFossils: 'Dear {player},\n\nThe fossil hall of {town} is complete, every bone of it, thanks to all of you. Do drop by and admire your work.\n\nGratefully,\n{curator}',
  letterFish: 'Dear {player},\n\nThe aquarium of {town} now has every fish we know of. The tanks are full and so is my heart.\n\nWarmly,\n{curator}',
} as const satisfies StringBank;
